import { render, staticRenderFns } from "./HostelCreate.vue?vue&type=template&id=04b82cbc"
import script from "../../controllers/hostel/hostel-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/hostel/hostel-create.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports